import { motion } from "framer-motion";

export const SectionHeading = ({
  eyebrow,
  title,
  subtitle,
  align = "left",
  goldWord,
  className = "",
}) => {
  const alignment =
    align === "center" ? "items-center text-center" : "items-start text-left";

  // Allow simple gold-word highlighting inside the title string
  let renderedTitle = title;
  if (goldWord && typeof title === "string" && title.includes(goldWord)) {
    const [a, b] = title.split(goldWord);
    renderedTitle = (
      <>
        {a}
        <span className="gold-text">{goldWord}</span>
        {b}
      </>
    );
  }

  return (
    <div className={`flex flex-col ${alignment} max-w-3xl ${align === "center" ? "mx-auto" : ""} ${className}`}>
      {eyebrow && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="eyebrow mb-5"
        >
          <span className="hairline" />
          {eyebrow}
        </motion.div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="font-display text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] text-white text-balance"
      >
        {renderedTitle}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className={`mt-6 text-base sm:text-lg text-white/60 max-w-2xl ${align === "center" ? "mx-auto" : ""}`}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};

export default SectionHeading;
